import React from 'react';
import Ratings from 'gatsby-core-theme/src/components/atoms/ratings';

export default (props) => <Ratings {...props} currency='R' />